import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  AfterViewInit,
  ViewChild,
  ElementRef,
  Renderer2
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  imports: [
    NgIf
  ],
  standalone: true,
  styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent implements OnChanges, AfterViewInit {
  @ViewChild('theFrame') iframeRef!: ElementRef<HTMLIFrameElement>;
  @Input() pdfUrl: string = '';
  safePdfUrl: SafeResourceUrl | null = null;
  isLoading: boolean = true;
  hasError: boolean = false;
  isMobile: boolean = false;


  constructor(private sanitizer: DomSanitizer, private renderer: Renderer2) {
    this.checkMobile();
  }

  ngAfterViewInit() {
    this.checkMobile();
    const iframe = this.iframeRef.nativeElement;
    iframe.onload = () => {
      const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
      if (iframeDoc) {
        setTimeout(() => {
          const imgs = iframeDoc.getElementsByTagName('img');
          if (imgs.length > 0) {
            this.renderer.setStyle(imgs[0], 'width', '100%');
          }
        }, 100);
      }
    };
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['pdfUrl']) {
      this.resetState();
      this.loadPdf();
    }
  }

  private checkMobile(): void {
    this.isMobile = window.innerWidth <= 576;
  }

  private loadPdf(): void {
    if (!this.pdfUrl) {
      this.safePdfUrl = null;
      this.isLoading = false;
      return;
    }
    if (this.pdfUrl.startsWith('blob:')) {
      this.safePdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.pdfUrl);
    } else {
      const pdfUrlWithParams = `${this.pdfUrl}`;
      this.safePdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrlWithParams);
    }
  }

  private resetState(): void {
    this.isLoading = true;
    this.hasError = false;
  }

  onLoad(): void {
    this.isLoading = false;
    this.hasError = false;
  }

  onError(): void {
    this.isLoading = false;
    this.hasError = true;
    console.error('Failed to load PDF:', this.pdfUrl);
  }
  reloadPdf(): void {
    this.resetState();
    this.loadPdf();
  }
}
